import React, { Component } from 'react';
import update from 'immutability-helper';

import ContentWrapper from '../../components/ContentWrapper';
import PageTitle from '../../components/PageTitle';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import Floorplan from '../../components/Floorplan/Floorplan';

import { Link, Redirect } from 'react-router-dom';

import 'font-awesome/css/font-awesome.min.css';
import Files from 'react-files';
import Modal from '@atlaskit/modal-dialog';
// import interact from 'interactjs';


import {
  setTranslateX,
  setTranslateY,
  setZoom,
  loadFloorplans,
  setActiveFloorplan,
  showHidePathPopover,
  setPathPopoverX,
  setPathPopoverY,
  showHidePointPopover,
  editFloorplan,
  addFloorplanSkin,
  getFloorplanSkin,
  removeFloorplanSkin,
} from '../../reducers/floorplans';

class EditFloorplan extends Component {

  state = {
    floorplanLevel: {value: '', touched: false, error: false, errorText: ''},
    floorplanName: {value: '', touched: false, error: false, errorText: ''},
    form: {error: false},
    updated: false,
    floorplan: null,
    floorplanSkin: null,
    isSkinOnEdit: false
  }

  changeFloorplanLevel = (event) => {
    this.setState(update(this.state, {floorplanLevel: {value: {$set: event.target.value}, touched: {$set: true}}}), () => {
      if(this.state.floorplanLevel.value.length === 0){
        this.setState(update(this.state, {floorplanLevel: { error: {$set: true}, errorText: {$set: 'Floorplan Level must not be empty'}}}), () => { this.validateFormFields(); });
      } else {

        const floorplanLevelExists = this.props.floorplans.find((floorplan) => {
          return floorplan.floorplan_level === this.state.floorplanLevel.value;
        });

        if(floorplanLevelExists){
          // this.setState(update(this.state, {floorplanLevel: { error: {$set: true}, errorText: {$set: 'Floorplan Level already exists'}}}), () => { this.validateFormFields(); });
          if(this.state.floorplanLevel.value === this.state.floorplan.floorplan_level){
            this.setState(update(this.state, {floorplanLevel: { error: {$set: false}, errorText: {$set: ''}}}), () => { this.validateFormFields(); });
          } else {
            this.setState(update(this.state, {floorplanLevel: { error: {$set: true}, errorText: {$set: 'Floorplan Level already exists'}}}), () => { this.validateFormFields(); });
          }
        } else {
          this.setState(update(this.state, {floorplanLevel: { error: {$set: false}, errorText: {$set: ''}}}), () => { this.validateFormFields(); });
        }
      }
    });
  }

  changeFloorplanName = (event) => {
    this.setState(update(this.state, {floorplanName: {value: {$set: event.target.value}, touched: {$set: true}}}), () => {
      if(this.state.floorplanName.value.length === 0){
        this.setState(update(this.state, {floorplanName: { error: {$set: true}, errorText: {$set: 'Floorplan Name must not be empty'}}}), () => { this.validateFormFields(); });
      } else {
        const floorplanNameExists = this.props.floorplans.find((floorplan) => {
          return floorplan.floorplan_name === this.state.floorplanName.value;
        });
        
        if(floorplanNameExists){
          // this.setState(update(this.state, {floorplanName: { error: {$set: true}, errorText: {$set: 'Floorplan Name already exists'}}}), () => { this.validateFormFields(); });
          if(this.state.floorplanName.value === this.state.floorplan.floorplan_name){
            this.setState(update(this.state, {floorplanName: { error: {$set: false}, errorText: {$set: ''}}}), () => { this.validateFormFields(); });
          } else {
            this.setState(update(this.state, {floorplanName: { error: {$set: true}, errorText: {$set: 'Floorplan Name already exists'}}}), () => { this.validateFormFields(); });
          }
        } else {
          this.setState(update(this.state, {floorplanName: { error: {$set: false}, errorText: {$set: ''}}}), () => { this.validateFormFields(); });
        }
      }
    });
  }

  validateFormFields = () => {
    if(this.state.floorplanName.error || this.state.floorplanLevel.error){
      this.setState(update(this.state, {form: {error: {$set: true}}}));
    } else {
      this.setState(update(this.state, {form: {error: {$set: false}}}));
    }
  }

  componentWillReceiveProps = () => {
    this.validateFormFields();
    const floorplan = this.props.floorplans.find((floorplan) => {
      return floorplan.floorplan_id === parseInt(this.props.match.params.id, 10);
    });

    if(floorplan){
      this.setState(update(this.state, {floorplan: {$set: floorplan}, floorplanLevel: {value: {$set: floorplan.floorplan_level}}, floorplanName: {value: {$set: floorplan.floorplan_name}}}));
    }
    
  }

  componentDidMount = () => {
    this.props.getFloorplanSkin();
    const floorplan = this.props.floorplans.find((floorplan) => {
      return floorplan.floorplan_id === parseInt(this.props.match.params.id, 10);
    });
   
    if(floorplan){
      this.setState(update(this.state, {floorplan: {$set: floorplan}, floorplanLevel: {value: {$set: floorplan.floorplan_level}}, floorplanName: {value: {$set: floorplan.floorplan_name}}}));
    }
  }

  componentDidUpdate = () => {    
  }

  editFloorplan = (event) => {
    event.preventDefault();

    if(!this.state.form.error) { 
      const floorplan = {
        floorplan_name: this.state.floorplanName.value,
        floorplan_level: this.state.floorplanLevel.value,
        is_active: '1'
      };
  
      const data = new FormData();
      data.append('data', JSON.stringify(floorplan));
      this.props.editFloorplan(this.state.floorplan.floorplan_id, data, () => {
        // this.setState({updated: true});
      });
    }
    this.addFloorplanSkin();
  }

  handleFileChange = (file) => {
    if(file.length > 1) {
      file.splice(0,file.length-1)
    }
    this.state.floorplanSkin = file[0];
    this.setState({isSkinOnEdit: true});
  }

  addFloorplanSkin = () => {

    if(!this.state.form.error) { 
      const floorplanSkin = {
        is_skin: '1',
        is_active: '1'
      };

      const data = new FormData()
      data.append('data', JSON.stringify(floorplanSkin));
      data.append('file', this.state.floorplanSkin);

      this.props.addFloorplanSkin(this.state.floorplan.floorplan_id, data, () => {
      });
    }
  }

  removeFloorplanSkin = () => {
    if(this.props.floorplanSkin.floorplan_file){
      if(window.confirm(`Do you want to remove skin?`)){
        this.props.removeFloorplanSkin(this.props.activeFloorplanID, () => {
          window.location.reload();
        })
      }
    } else {
      window.alert(`No skin avalable for this floorplan. Nothing to remove.`);
    }    
  }

  showModal = () => {
    this.setState({ isModalOpen: true });
  }

  hideModal = () => {
    this.setState({ isModalOpen: false });
  }

  render() {

    if(this.state.updated) {
      return <Redirect to='/floorplans' />
    }

    return (
      <ContentWrapper>
        <div className="inner-content" style={{height: '100vh', display: 'flex', flexDirection: 'column'}}>
          <PageTitle>Edit Floorplan</PageTitle>

          <div className="container-fluid" style={{marginBottom: '10px'}}>
            <div className="row" role="toolbar">
              <div className="col-md-3">
                
              <div className="form-inline">
              <label htmlFor="floorplanLevel" style={{marginRight: '10px'}}>Floorplan Level</label>
              <div className="row">
                  <div className="col-md-12">
                  
                  <input id="floorplanLevel" type="text" className={`form-control ` + (this.props.isAddingFloorplan ? 'disabled' : '') + ` ` + (this.state.floorplanLevel.error && this.state.floorplanLevel.touched ? 'is-invalid' : '')} value={this.state.floorplanLevel.value} onChange={this.changeFloorplanLevel} style={{width: '150px'}} />
                  {this.state.floorplanLevel.error && 
                    <div className="invalid-feedback" style={{position: 'absolute'}}>
                      {this.state.floorplanLevel.errorText}
                    </div>
                  }
                  </div>
                </div>
              </div>
              </div>
              <div className="col-md-7">
                <div className="row">                  
                  <div className="col-md-12">
                    <div className="form-inline">
                      <label htmlFor="floorplanName" style={{marginRight: '10px'}}>Floorplan Name</label>
                      <div className="row">                  
                        <div className="col-md-12">
                          <input id="floorplanName" type="text" className={`form-control ` + (this.props.isAddingFloorplan ? 'disabled' : '')  + ` ` + (this.state.floorplanName.error && this.state.floorplanName.touched ? 'is-invalid' : '')} value={this.state.floorplanName.value} onChange={this.changeFloorplanName} style={{width: '150px'}} />
                          {this.state.floorplanName.error &&
                            <div className="invalid-feedback" style={{position: 'absolute'}}>
                              {this.state.floorplanName.errorText}
                            </div>
                          }
                        </div>
                      </div>
                      <button className={`btn btn-outline-secondary `} onClick={this.showModal} title="View Floorplan Skin" style={{marginLeft: '10px'}}><i className="fa fa-eye" aria-hidden="true"></i></button>
                      <button className={`btn btn-outline-secondary `} onClick={this.removeFloorplanSkin} title="Remove Floorplan Skin" style={{marginLeft: '10px'}}><i className="fa fa-trash" aria-hidden="true"></i></button>
                      {
                        this.state.isModalOpen && (
                            <Modal
                              heading=" "
                              actions={[{ text: 'Close', onClick: this.hideModal }]}
                              onClose={this.hideModal}
                            >
                              <div style={{ padding: 16 }}>
                              {this.props.floorplanSkin.floorplan_file &&
                                  <img src={`${this.props.floorplanSkin.floorplan_file}`} alt="Moar cupcakes" style={{maxWidth: '100%'}}/>
                              }
                              {!this.props.floorplanSkin.floorplan_file &&
                                <em>No skin assigned</em>
                              }
                              </div>
                            </Modal>
                        )
                      }
                      <Files name="svg" accepts={['.svg', '.png']} clickable onChange={this.handleFileChange} maxFiles="2">
                        <button className="btn btn-primary" style={{marginLeft: '10px'}}>Add Skin</button>
                      </Files>
                      {this.state.floorplanSkin &&
                        (<label style={{marginLeft: '10px'}}>{this.state.floorplanSkin.name}</label>)
                      }
                    </div>
                  </div>
                </div>

              </div>
              <div className="col-md-2 text-right">
                <Link to='/floorplans'><button className="btn btn-light" style={{marginRight: '20px'}}>Cancel</button></Link>
                <button className={`btn btn-primary ` + (this.props.isEditingFloorplan ? 'disabled' : '') + ' ' + (this.state.form.error ? 'disabled' : '')} onClick={this.editFloorplan}>Edit Floorplan</button>
              </div>
            </div>
          </div>

          <div className="container-fluid" style={{flexGrow: 1, display: 'flex', flexDirection: 'column'}}>
            <div className="row" style={{height: '100%', display: 'flex', flexGrow: 1, flexDirection: 'column'}}>
              <div className="col-md-12" style={{height: '100%', display: 'flex', flexGrow: 1, flexDirection: 'column'}}><br></br>
                <div style={{height: '100%', display: 'flex', flexGrow: 1, flexDirection: 'column', border: 'solid 1px rgba(0,0,0,.1)', padding: '0px'}}>
                  {this.state.floorplan &&
                    <Floorplan key={`floorplan-${this.state.floorplan.floorplan_id}`} floorplan_id={this.state.floorplan.floorplan_id} floorplanURL={`${this.state.floorplan.floorplan_file}`} toolbar={`drag`} />
                  }
                </div>
              </div>
            </div>
          </div>

        </div>
      </ContentWrapper>
    )
  }
}


const mapStateToProps = state => ({
  floorplans: state.floorplans.floorplans,
  floorplanSkin: state.floorplans.floorplanSkin,
  activeFloorplanID: state.floorplans.activeFloorplanID,
  translateX: state.floorplans.translateX,
  translateY: state.floorplans.translateY,
  zoom: state.floorplans.zoom,
  showPathPopover: state.floorplans.showPathPopover,
  pathPopoverX: state.floorplans.pathPopoverX,
  pathPopoverY: state.floorplans.pathPopoverY,
  showPointPopover: state.floorplans.showPointPopover,
  pointPopoverX: state.floorplans.pointPopoverX,
  pointPopoverY: state.floorplans.pointPopoverY,
  tempAddFloorplan: state.floorplans.tempAddFloorplan,
  isEditingFloorplan: state.floorplans.isEditingFloorplan
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      loadFloorplans,
      getFloorplanSkin,
      setActiveFloorplan,
      setTranslateX,
      setTranslateY,
      setZoom,
      showHidePathPopover,
      setPathPopoverX,
      setPathPopoverY,
      showHidePointPopover,
      editFloorplan,
      addFloorplanSkin,
      removeFloorplanSkin,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(EditFloorplan);


// WEBPACK FOOTER //
// ./src/modules/Floorplans/EditFloorplan.js